import React, { FC, PropsWithChildren, useEffect } from 'react';
import { Permissions, hasAnyRight } from 'services/RightsService';
import { useGetAppContextSubscription } from 'queries/AppContextSubscription/appContextSubscription.queries';
import { LoadingPage } from 'components/common/Loading';
import { useLocation, useNavigate } from 'react-router';
import { RoutePaths } from './RoutePaths';

interface IProtectedRouteProps extends PropsWithChildren {
    permissionsForOtherProfile: Permissions[],
}

export const ProtectedRoute: FC<IProtectedRouteProps> = ({ children, permissionsForOtherProfile }) => {
    const { data, isError, isFetched, isFetching } = useGetAppContextSubscription();
    const navigate = useNavigate();   
    const location = useLocation();

    const query = new URLSearchParams(location.search);
    const paramUser = query.get('icId') || undefined;

    useEffect(() => {
        if (isFetched && !hasAnyRight(data?.loggedUser, permissionsForOtherProfile) && paramUser) {
            navigate(RoutePaths.Errors.NotAuthorized.url());
        }
    }, [isFetched, data?.loggedUser, permissionsForOtherProfile, paramUser]);

     if (isFetching || !data?.loggedUser) {
        return <LoadingPage />;
    }

    if (hasAnyRight(data?.loggedUser, [Permissions.SGM_DEFAULT])) {
        return children;
    }

    if (isError || isFetched || data?.loggedUser) {
        navigate(RoutePaths.Errors.NotAuthorized.url());
    }
};
